export default "__VITE_ASSET__B__EgW1$__"